export default {"src":"/_next/static/media/icon-3.0cf25aa9.svg","height":81,"width":88,"blurWidth":0,"blurHeight":0};